// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"732e13a7","276":"fb14bc49","510":"12fba4d9","560":"427a36f7","658":"02efd5b9","708":"f7a4def0"}[chunkId] + ".chunk.js";
};